import Ending from './Ending.jsx';

export default Ending;
